import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ShoppingBag, Search, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>404 – Lehte ei leitud | Tõuks.ee</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-[80vh] flex items-center justify-center px-4">
        <div className="max-w-lg w-full text-center">
          {/* Big 404 */}
          <div className="relative mb-8">
            <p className="text-[10rem] font-black text-[#4FC1E9]/10 leading-none select-none">
              404
            </p>
            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src="https://res.cloudinary.com/daka2lob2/image/upload/v1751272742/Touks_logo3_ed9w6g.png"
                alt="Tõuks.ee"
                className="h-16 opacity-60"
              />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-3">
            Lehte ei leitud
          </h1>
          <p className="text-gray-500 mb-2">
            Aadress <code className="bg-gray-100 px-2 py-0.5 rounded text-sm text-gray-700">{location.pathname}</code> ei eksisteeri.
          </p>
          <p className="text-gray-400 text-sm mb-10">
            Võib-olla kirjutasid aadressi valesti või on leht eemaldatud.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
            <Link
              to="/"
              className="flex items-center justify-center gap-2 bg-[#4FC1E9] hover:bg-[#3ba8d0] text-white font-semibold px-6 py-3 rounded-full transition-colors"
            >
              <Home className="w-4 h-4" />
              Avalehele
            </Link>
            <Link
              to="/toukeratas"
              className="flex items-center justify-center gap-2 bg-white border border-gray-200 hover:border-[#4FC1E9] text-gray-700 hover:text-[#4FC1E9] font-semibold px-6 py-3 rounded-full transition-colors"
            >
              <ShoppingBag className="w-4 h-4" />
              Vaata tooteid
            </Link>
          </div>

          {/* Quick links */}
          <div className="border-t border-gray-100 pt-8">
            <p className="text-gray-400 text-sm mb-4">Kasulikud lingid</p>
            <div className="flex flex-wrap gap-3 justify-center text-sm">
              {[
                { to: '/toukeratas/tald', label: 'Tallad' },
                { to: '/toukeratas/lenks', label: 'Lenksud' },
                { to: '/toukeratas/rattad', label: 'Rattad' },
                { to: '/toukeratas/brandid', label: 'Brändid' },
                { to: '/kontakt', label: 'Kontakt' },
                { to: '/kohaletoimetamine', label: 'Saatmisinfo' },
              ].map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="text-[#4FC1E9] hover:underline"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
